<template>
  <div class="cell small-12 medium-6 large-6">
    <Skeleton
      v-if="loading"
      :height="getImageHeight"
    />
    <Picture
      v-else
      :image-url="getHeroImageUrl"
      alt="Hero Image"
      :image-intrinsic-width="getImageWidth"
    />
  </div>
</template>

<script>
import Picture from '@atomic-ui/picture';
import Skeleton from '@atomic-ui/skeleton';
import constants from '../../utils/constants';

const BASE_URL = 'https://slimages.macysassets.com';

export default {
  name: 'ProsContentCollectionHeroImage',
  components: {
    Picture,
    Skeleton,
  },
  props: {
    recommendationData: {
      type: Object,
      default: () => ({}),
    },
    heroImageStyle: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getHeroImageUrl() {
      return `${BASE_URL}${this.recommendationData.content?.contentPath}`;
    },
    getImageHeight() {
      return this.heroImageStyle.height || '100%';
    },
    getImageWidth() {
      const windowSize = Math.ceil(window.innerWidth);
      let imageSize = windowSize > 900 ? 900 : windowSize;
      if (windowSize < constants.BREAK_POINTS.MEDIUM) {
        imageSize = windowSize > 800 ? 800 : windowSize;
      }
      return imageSize;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(img) {
  height: 100%;
}
</style>
